window.$ = window.jQuery = require('jquery');

function getCardFlag(cardnumber) {
    var cardnumber = cardnumber.replace(/[^0-9]+/g, '');
    console.log(cardnumber);

    var cards = {
        Visa: /^4\d{0,15}/,
        Master: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
        Diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
        Amex: /^3[47]\d{0,13}/,
        Discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
        Hipercard: /^606282|^3841(?:[0|4|6]{1})0/,
        Elo: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|50(9[0-9][0-9][0-9])|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|05([7-9])|06([0-9])|07([0-9])|08([0-9])|4([0-3][0-9]|8[5-9]|9[0-9])|5([0-9][0-9]|3[0-8])|9([0-6][0-9]|7[0-8])|7([0-2][0-9])|541|700|720|727|901)|65165([2-9])|6516([6-7][0-9])|65500([0-9])|6550([0-5][0-9])|655021|65505([6-7])|6516([8-9][0-9])|65170([0-4]))/,
        JCB: /^(?:35\d{0,2})\d{0,12}/,
        Discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/
    };

    for (var flag in cards) {
        if (cards[flag].test(cardnumber)) {
            return flag;
        }
    }
    return false;
}

document.getElementById('creditCardNumber').addEventListener('keyup', function () {
    var card = getCardFlag(this.value);
    $("#cardFlag").val(card);

});
var $recaptcha = document.querySelector('#g-recaptcha-response');

if ($recaptcha) {
    $recaptcha.setAttribute("required", "required");
}


$(document).ready(function () {
    jQuery.extend(jQuery.validator.messages, {
        required: "Campo obrigatório.",
        remote: "Please fix this field.",
        email: "Este email não é valido.",
        url: "Please enter a valid URL.",
        date: "Please enter a valid date.",
        dateISO: "Please enter a valid date (ISO).",
        number: "Please enter a valid number.",
        digits: "Please enter only digits.",
        creditcard: "Please enter a valid credit card number.",
        equalTo: "Please enter the same value again.",
        accept: "Please enter a value with a valid extension.",
        maxlength: jQuery.validator.format("Please enter no more than {0} characters."),
        minlength: jQuery.validator.format("Número de dígitos inválido."),
        rangelength: jQuery.validator.format("Please enter a value between {0} and {1} characters long."),
        range: jQuery.validator.format("Please enter a value between {0} and {1}."),
        max: jQuery.validator.format("Please enter a value less than or equal to {0}."),
        min: jQuery.validator.format("Please enter a value greater than or equal to {0}.")
    });

    function getWordCount(wordString) {
        var words = wordString.split(" ");
        words = words.filter(function (words) {
            return words.length > 0
        }).length;
        return words;
    }

    //add the custom validation method
    jQuery.validator.addMethod("wordCount",
        function (value, element, params) {
            var count = getWordCount(value);
            if (count >= params[0]) {
                return true;
            }
        },
        jQuery.validator.format("Digite seu nome completo.")
    );

    jQuery.validator.addMethod("cpf", function (value, element) {
        value = jQuery.trim(value);

        value = value.replace('.', '');
        value = value.replace('.', '');
        cpf = value.replace('-', '');
        while (cpf.length < 11) cpf = "0" + cpf;
        var expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
        var a = [];
        var b = new Number;
        var c = 11;
        for (i = 0; i < 11; i++) {
            a[i] = cpf.charAt(i);
            if (i < 9) b += (a[i] * --c);
        }
        if ((x = b % 11) < 2) { a[9] = 0 } else { a[9] = 11 - x }
        b = 0;
        c = 11;
        for (y = 0; y < 10; y++) b += (a[y] * c--);
        if ((x = b % 11) < 2) { a[10] = 0; } else { a[10] = 11 - x; }

        var retorno = true;
        if ((cpf.charAt(9) != a[9]) || (cpf.charAt(10) != a[10]) || cpf.match(expReg)) retorno = false;

        return this.optional(element) || retorno;

    }, "Informe um CPF válido");

    $("#paymentForm").validate({
        rules: {
            name: {
                required: true,
                wordCount: ['2']
            },
            cpf: {
                required: true,
                cpf: true
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
                minlength: 15
            },
            zipcode: {
                required: true,
            },
            address: {
                required: true,
            },
            district: {
                required: true,
            },
            number: {
                required: true,
            },
            city: {
                required: true,
            },
            state: {
                required: true,
            },
            termsOfUse: {
                required: true,
            },
        },
        submitHandler: function (form) {
            form.submit();
        }
    });

});